import { createContext } from 'react';

const SwContext = createContext();

export const SwProvider = SwContext.Provider;
export default SwContext;
